import { render } from "./addLayerProductionProcessModal.vue?vue&type=template&id=364d13a1&ts=true"
import script from "./addLayerProductionProcessModal.vue?vue&type=script&lang=ts"
export * from "./addLayerProductionProcessModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__